// extracted by mini-css-extract-plugin
module.exports = {"learnMoreContainer":"styles_learnMoreContainer__1rRV6","content":"styles_content__1tpgg","title":"styles_title__G7Zig"};